/* ============================================================
   MUHRA — SIZE ADVISOR JS v1
   File: assets/muhra-size-advisor.js

   3-step conversational size recommender.
   Algorithm: ease-based matching (garment bust vs body bust).
   No external dependencies. No API calls. Instant result.
   ============================================================ */

(function () {
  'use strict';

  /* ──────────────────────────────────────────────
     EASE TARGETS  (garment_bust - body_bust, cm)
     Woven shirt / Oxford cotton / Modest-wear bias
  ────────────────────────────────────────────── */
  var EASE = {
    fitted:  { ideal: 8,  low: 4,  high: 12 },
    regular: { ideal: 12, low: 8,  high: 17 },
    relaxed: { ideal: 18, low: 13, high: 26 }
  };

  /* ──────────────────────────────────────────────
     HEIGHT → approximate torso length (cm)
     Used to interpret garment length relative to body
  ────────────────────────────────────────────── */
  var TORSO = {
    'under158': 54,
    '158-163':  56,
    '163-168':  58,
    '168-173':  60,
    'over173':  62
  };

  /* ──────────────────────────────────────────────
     STATE
  ────────────────────────────────────────────── */
  var state = {
    bust:   null,   // number (cm)
    height: null,   // string key
    fit:    null    // 'fitted' | 'regular' | 'relaxed'
  };

  /* ──────────────────────────────────────────────
     INIT — runs once per widget on the page
  ────────────────────────────────────────────── */
  function init() {
    var widget = document.querySelector('.muhra-size-advisor[data-advisor]');
    if (!widget || widget._msaInit) return;
    widget._msaInit = true;

    /* Read product size data injected by Liquid */
    var sizes = window.muhraAdvisorSizes || [];
   sizes = sizes.filter(function (s) {
  var b = parseFloat(String(s.bust).replace(/[^0-9.]/g, ''));
  s._bust        = isNaN(b) ? null : b;
  s._length      = parseFloat(String(s.length       || 0).replace(/[^0-9.]/g, '')) || 0;
  s._lengthFront = parseFloat(String(s.length_front || 0).replace(/[^0-9.]/g, '')) || 0;
  s._lengthBack  = parseFloat(String(s.length_back  || 0).replace(/[^0-9.]/g, '')) || 0;
  return s._bust !== null;
});

    if (!sizes.length) return;

    /* ── DOM refs ── */
    var steps     = widget.querySelectorAll('.muhra-size-advisor__step');
    var dots      = widget.querySelectorAll('.muhra-size-advisor__progress-dot');
    var loadingEl = widget.querySelector('.muhra-size-advisor__loading');
    var resultEl  = widget.querySelector('.muhra-size-advisor__result');

    /* ── Step 1: Bust ── */
    var bustWrap  = widget.querySelector('.muhra-size-advisor__input-wrap');
    var bustInput = widget.querySelector('#msa-bust');
    var btn1      = widget.querySelector('[data-msa-next="1"]');

    btn1 && btn1.addEventListener('click', function () {
      var val = parseFloat(bustInput.value);
      if (isNaN(val) || val < 60 || val > 160) {
        bustWrap && bustWrap.classList.add('has-error');
        bustInput.focus();
        return;
      }
      bustWrap && bustWrap.classList.remove('has-error');
      state.bust = val;
      goToStep(2, steps, dots);
    });

    bustInput && bustInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') btn1 && btn1.click();
    });

    bustInput && bustInput.addEventListener('input', function () {
      bustWrap && bustWrap.classList.remove('has-error');
    });

    /* ── Step 2: Height ── */
    var heightSelect = widget.querySelector('#msa-height');
    var btn2         = widget.querySelector('[data-msa-next="2"]');

    btn2 && btn2.addEventListener('click', function () {
      if (!heightSelect || !heightSelect.value) return;
      state.height = heightSelect.value;
      goToStep(3, steps, dots);
    });

    /* ── Step 3: Fit preference ── */
    var fitCards = widget.querySelectorAll('.muhra-size-advisor__fit-card');
    var btn3     = widget.querySelector('[data-msa-next="3"]');

    fitCards.forEach(function (card) {
      card.addEventListener('click', function () {
        fitCards.forEach(function (c) { c.classList.remove('is-selected'); });
        card.classList.add('is-selected');
        state.fit = card.dataset.fit;
      });
      /* Keyboard accessibility */
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); card.click(); }
      });
    });

    btn3 && btn3.addEventListener('click', function () {
      if (!state.fit) return;
      compute(sizes, steps, loadingEl, resultEl);
    });

    /* ── Reset ── */
    widget.addEventListener('click', function (e) {
      if (!e.target.classList.contains('muhra-size-advisor__reset')) return;
      state = { bust: null, height: null, fit: null };
      if (bustInput)    bustInput.value = '';
      if (bustWrap)     bustWrap.classList.remove('has-error');
      if (heightSelect) heightSelect.value = '';
      fitCards.forEach(function (c) { c.classList.remove('is-selected'); });
      resultEl.classList.remove('is-visible');
      resultEl.innerHTML = '';
      if (loadingEl) loadingEl.classList.remove('is-visible');
      goToStep(1, steps, dots);
    });

    /* Start on step 1 */
    goToStep(1, steps, dots);
  }

  /* ──────────────────────────────────────────────
     NAVIGATION
  ────────────────────────────────────────────── */
  function goToStep(n, steps, dots) {
    steps.forEach(function (s, i) {
      s.classList.toggle('is-active', i === n - 1);
    });
    dots.forEach(function (d, i) {
      d.classList.toggle('is-active', i < n);
    });
  }

  /* ──────────────────────────────────────────────
     COMPUTE — show loading then render result
  ────────────────────────────────────────────── */
  function compute(sizes, steps, loadingEl, resultEl) {
    /* Hide all steps, show loader */
    steps.forEach(function (s) { s.classList.remove('is-active'); });
    if (loadingEl) loadingEl.classList.add('is-visible');

    /* Small delay for feel — makes it feel considered */
    setTimeout(function () {
      var rec = recommend(sizes, state.bust, state.height, state.fit);
      if (loadingEl) loadingEl.classList.remove('is-visible');
      renderResult(resultEl, rec);
      resultEl.classList.add('is-visible');
    }, 950);
  }

  /* ──────────────────────────────────────────────
     RECOMMEND ALGORITHM
     Scores each size by how close the ease is to
     the target for the chosen fit preference.
     Returns the best-matching size with context.
  ────────────────────────────────────────────── */
  function recommend(sizes, userBust, heightKey, fitPref) {
    var target = EASE[fitPref] || EASE.regular;
    var best       = null;
    var bestScore  = -Infinity;

    sizes.forEach(function (s) {
      if (s._bust === null) return;
      var ease  = s._bust - userBust;
      /* Score: distance from ideal ease, penalised outside range */
      var score = 100 - Math.abs(ease - target.ideal) * 7;
      if (ease < target.low - 3)  score -= 30;  /* too tight */
      if (ease > target.high + 3) score -= 20;  /* too generous */
      if (score > bestScore) { bestScore = score; best = s; }
    });

    if (!best) return null;

    var ease       = best._bust - userBust;
    var confidence = bestScore >= 85 ? 'high' : 'medium';

    /* Detect if between sizes */
    var betweenSizes = false;
    sizes.forEach(function (s) {
      if (s === best) return;
      var otherScore = 100 - Math.abs((s._bust - userBust) - target.ideal) * 7;
      if (Math.abs(otherScore - bestScore) < 10) betweenSizes = true;
    });

    return {
      sizeLabel:    best.label,
      ease:         Math.round(ease),
      easePhrase:   easePhrase(ease, fitPref),
    lengthNote:   lengthNote(best._length || best._lengthBack || best._lengthFront, heightKey),      weightNote:   best.weight || '',
      confidence:   confidence,
      betweenSizes: betweenSizes
    };
  }

  /* ──────────────────────────────────────────────
     EASE DESCRIPTION
     Personalised natural language based on actual ease value.
  ────────────────────────────────────────────── */
  function easePhrase(ease, fitPref) {
    if (ease <= 5)  return 'a precisely fitted silhouette — structured and close to the body';
    if (ease <= 9)  return 'a tailored fit with clean, polished lines';
    if (ease <= 13) return 'a comfortable ease — moves with you without feeling loose';
    if (ease <= 18) return 'a relaxed, effortless drape with room to breathe';
    if (ease <= 24) return 'a generous, flowy silhouette — elegant and understated';
    return 'an oversized, fashion-forward silhouette';
  }

  /* ──────────────────────────────────────────────
     LENGTH NOTE
     Contextualises garment length against height.
  ────────────────────────────────────────────── */
  function lengthNote(garmentLength, heightKey) {
    if (!garmentLength || garmentLength <= 0 || !heightKey) return null;
    var torso = TORSO[heightKey] || 58;
    var rel   = garmentLength - torso;

    if (rel >= 25) return 'At your height, the length falls well past the hip — a long, dramatic silhouette.';
    if (rel >= 17) return 'At your height, the hem lands gracefully below the hip.';
    if (rel >= 10) return 'At your height, the length covers the hip comfortably.';
    if (rel >= 4)  return 'At your height, the hem sits just below the waist.';
    return 'At your height, the shirt may feel shorter than expected — consider sizing up if length matters to you.';
  }

  /* ──────────────────────────────────────────────
     RENDER RESULT HTML
  ────────────────────────────────────────────── */
  var ICON_RULER = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="7" width="20" height="10" rx="1"/><line x1="7" y1="7" x2="7" y2="11"/><line x1="11" y1="7" x2="11" y2="13"/><line x1="15" y1="7" x2="15" y2="11"/></svg>';
  var ICON_HEIGHT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="12" y1="2" x2="12" y2="22"/><polyline points="8 6 12 2 16 6"/><polyline points="16 18 12 22 8 18"/></svg>';
  var ICON_CHECK  = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M8 12l2.5 2.5L16 9"/></svg>';
  var ICON_INFO   = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>';

  function renderResult(el, rec) {
    if (!rec) {
      el.innerHTML =
        '<p style="font-size:13px;color:#9b8878;padding-top:4px;">' +
        'We couldn\'t determine your size from the available data. Please contact us — we\'re happy to help.' +
        '</p>' +
        '<button class="muhra-size-advisor__reset">Try again</button>';
      return;
    }

    /* Confidence tag */
    var confClass = rec.confidence === 'high'
      ? 'muhra-size-advisor__result-conf--high'
      : 'muhra-size-advisor__result-conf--medium';
    var confText = rec.confidence === 'high' ? 'Strong match' : 'Good match';

    /* Build lines */
    var lines = '';

    /* Line 1: ease explanation */
    lines += line(ICON_RULER,
      'The bust gives you <strong>' + rec.ease + ' cm of ease</strong> — ' + rec.easePhrase + '.');

    /* Line 2: length note */
    if (rec.lengthNote) {
      lines += line(ICON_HEIGHT, rec.lengthNote);
    }

    /* Line 3: weight fitting */
    if (rec.weightNote) {
      lines += line(ICON_CHECK, 'Designed to fit up to <strong>' + rec.weightNote + '</strong> comfortably.');
    }

    /* Line 4: between sizes warning */
    if (rec.betweenSizes) {
      lines += line(ICON_INFO,
        'Your measurements sit between sizes. We recommend sizing <strong>up</strong> for a more comfortable, modest fit.');
    }

    el.innerHTML =
      '<div class="muhra-size-advisor__result-badge">' +
        '<span class="muhra-size-advisor__result-label">Your size</span>' +
        '<span class="muhra-size-advisor__result-size">' + rec.sizeLabel + '</span>' +
        '<span class="muhra-size-advisor__result-conf ' + confClass + '">' + confText + '</span>' +
      '</div>' +
      '<ul class="muhra-size-advisor__result-lines">' + lines + '</ul>' +
      '<button class="muhra-size-advisor__reset">Start over</button>';
  }

  function line(icon, text) {
    return '<li class="muhra-size-advisor__result-line">' + icon + '<span>' + text + '</span></li>';
  }

  /* ──────────────────────────────────────────────
     BOOT
  ────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

})();